/* Birth Profile Analyst, lightweight site translation (NL ⇄ EN)
   - Injects a language toggle (globe) into the nav on every page.
   - Remembers choice in localStorage and applies it across pages.
   - Translates text nodes + key attributes via a curated dictionary.
   - A MutationObserver catches dynamically rendered nodes (cart rows,
     autocomplete items, animated chart labels).
   Baseline language is Dutch; switching back to NL simply reloads. */
(function(){
  "use strict";

  var LANG_KEY = "bpa_lang";

  /* ---- Dictionary: Dutch (single-spaced) -> English ---- */
  var MAP = {
    // ---- Navigation / chrome ----
    "Home":"Home",
    "Diensten":"Services",
    "FAQ's":"FAQs",
    "FAQ’s":"FAQs",
    "Over ons":"About",
    "Privacybeleid":"Privacy Policy",
    "Cookievoorkeuren":"Cookie preferences",
    "Analyst · Geboorteprofiel":"Analyst · Birth Profile",
    "Birth Profile Analyst · Geboorteprofiel · 2026":"Birth Profile Analyst · Birth Profile · 2026",

    // ---- Home: hero ----
    "Persoonlijk · Geboorteprofiel":"Personal · Birth Profile",
    "Het":"The","getal":"number","onthult":"reveals",
    "Birth Profile Analyst vertaalt jouw geboortedatum, tijd en plaats naar een uniek persoonlijk inzicht. Laat je verrassen door wat jouw geboorte over jou vertelt. Zodat je met meer vertrouwen jouw eigen weg bewandelt.":
      "Birth Profile Analyst turns your date, time and place of birth into a unique personal insight. Let yourself be surprised by what your birth reveals about you, so you can walk your own path with greater confidence.",
    "Scroll om te ontdekken":"Scroll to discover",
    "Het verhaal erachter":"The story behind it",
    "Inzicht begint waar":"Insight begins where","aannames eindigen":"assumptions end",
    "Birth Profile Analyst is opgericht door Vicky Poeran vanuit één overtuiging: mensen worden niet gevormd door toeval. Ontdek de gedachte, de methode en de mens achter de analyses.":
      "Birth Profile Analyst was founded by Vicky Poeran from one conviction: people are not shaped by chance. Discover the thinking, the method and the person behind the analyses.",
    "Lees ons verhaal":"Read our story",

    // ---- Home + Services: tiers ----
    "Tier 01":"Tier 01","Tier 02":"Tier 02","Tier 03":"Tier 03",
    "Tier 04 · Teams & Organisaties":"Tier 04 · Teams & Organizations",
    "Rapport · 01":"Report · 01","Sessie · 02":"Session · 02",
    "Traject · 03":"Journey · 03","Teams · 04":"Teams · 04",
    "Persoonlijke":"Personal","Analyse":"Analysis",
    "Verdiepende Analyse":"In-depth Analysis","+ Live Sessie":"+ Live Session",
    "+ Persoonlijk Traject":"+ Personal Journey",
    "De Kracht van":"The Power of","het Team":"the Team",
    "Kijk verder":"Read more","Offerte":"Request quote",

    "Soms weet je dat er meer is in jij, maar weet je niet precies wat of waar te beginnen. Op basis van jouw geboortegegevens ontvang je een diepgaand rapport dat jouw unieke profiel blootlegt: praktisch toegankelijk, en verrassend eerlijk. Meer helderheid over jezelf, zonder dat je er iets voor hoeft te geloven.":
      "Sometimes you sense there's more to you, but you don't know exactly what, or where to begin. Based on your birth details you receive an in-depth report that uncovers your unique profile: practical, accessible and surprisingly honest. More clarity about yourself, without having to believe in anything.",
    "Ken je dat gevoel dat je iets leest en denkt: maar wat betekent dit nu voor mij? Die vraag beantwoorden we samen. Geen algemene verhalen, maar betekenis die direct verbonden is aan wie jij in staat.":
      "Know that feeling when you read something and think: but what does this actually mean for me? We answer that question together. No generic stories, meaning that connects directly to who you are.",
    "Het meest complete traject naar wie wij echt zijn en wat persoonlijke groei vraagt. Je ontvangt een diepgaand rapport én vier sessies waarin we jouw belangrijkste momenten naar een concreet aanpak vertalen. Stap voor stap, op jouw tempo, volledig afgestemd op wie jij bent en waar jij wilt staan.":
      "The most complete journey toward who you truly are and what personal growth asks of you. You receive an in-depth report plus four sessions in which we translate your key moments into a concrete approach. Step by step, at your own pace, fully tailored to who you are and where you want to be.",
    "Speciaal ontwikkeld voor bedrijven, teams en organisaties die beter willen samenwerken door meer inzicht te krijgen in elkaars kwaliteiten, communicatie en natuurlijke eigenschappen.":
      "Specially developed for companies, teams and organizations that want to work together better by gaining more insight into each other's strengths, communication and natural traits.",

    // list items (home + services + product)
    "Geschreven rapport":"Written report",
    "Geschreven PDF-rapport":"Written PDF report",
    "Gebaarde rapport":"Written report",
    "Uitgebreid rapport":"Extended report",
    "Direct na aanvraag in jouw inbox":"In your inbox right after ordering",
    "1 uur live sessie":"1-hour live session",
    "Persoonlijk plan":"Personal plan",
    "Persoonlijk plan + samenvatting":"Personal plan + summary",
    "4 live sessies":"4 live sessions",
    "4 live sessies van 60 min":"4 live sessions of 60 min",
    "Plan van aanpak":"Action plan",
    "Plan van aanpak + begeleiding":"Action plan + guidance",
    "Evaluatie / statistieken overzicht":"Evaluation / statistics overview",
    "Persoonlijke teamanalyse":"Personal team analysis",
    "Live workshop op locatie of online":"Live workshop on location or online",
    "Live workshop, locatie of online":"Live workshop, on location or online",
    "Praktische handvatten voor teamdynamiek":"Practical tools for team dynamics",

    // price small-caps
    "tijdelijk":"limited time","vanaf 149":"from 149","volledig traject":"full journey",
    "traject":"journey","per offerte":"by quote","Op aanvraag":"On request",
    "Eenmalig · incl. btw · digitale levering":"One-time · incl. VAT · digital delivery",
    "Eenmalig · incl. btw · incl. live sessie":"One-time · incl. VAT · live session included",
    "Eenmalig · incl. btw · volledig traject (4 sessies)":"One-time · incl. VAT · full journey (4 sessions)",

    // home chart titles (SVG)
    "PERSOONLIJK ENERGIEPATROON":"PERSONAL ENERGY PATTERN",
    "DOMEINEN VAN INZICHT":"DOMAINS OF INSIGHT",
    "PERSOONLIJK TRAJECT":"PERSONAL JOURNEY",
    "DE KRACHT VAN HET TEAM":"THE POWER OF THE TEAM",
    "KERN":"CORE","WERK":"WORK","LIEFDE":"LOVE","GROEI":"GROWTH","PAD":"PATH",
    "WIL":"WILL","HART":"HEART","GEEST":"MIND","RUST":"REST","OKT":"OCT",

    // ---- Services page ----
    "Onze pakketten":"Our packages",
    "Van een diepgaand persoonlijk rapport tot een volledig begeleid traject, en een aparte workshop voor teams. Kies wat bij jou of je organisatie past.":
      "From an in-depth personal report to a fully guided journey, plus a separate workshop for teams. Choose what suits you or your organization.",
    "Tier 01 · Rapport":"Tier 01 · Report",
    "Tier 02 · Rapport + sessie":"Tier 02 · Report + session",
    "Tier 03 · Volledig traject":"Tier 03 · Full journey",
    "Tier 04 · Teams & organisaties":"Tier 04 · Teams & organizations",
    "Populair":"Popular",
    "Op basis van jouw geboortegegevens ontvang je een diepgaand rapport dat jouw unieke profiel blootlegt, praktisch, toegankelijk en verrassend eerlijk.":
      "Based on your birth details you receive an in-depth report that uncovers your unique profile, practical, accessible and surprisingly honest.",
    "Het rapport, plus één live sessie van een uur waarin we de inzichten samen vertalen naar jouw situatie. Geen algemene verhalen, betekenis die echt over jou gaat.":
      "The report, plus a one-hour live session in which we translate the insights together to your situation. No generic stories, meaning that's really about you.",
    "Het meest complete traject: een uitgebreid rapport én vier live sessies waarin we jouw patronen vertalen naar een concrete, persoonlijke aanpak.":
      "The most complete journey: an extended report plus four live sessions in which we translate your patterns into a concrete, personal approach.",
    "Voor bedrijven en teams die beter willen samenwerken door meer inzicht in elkaars kwaliteiten, communicatie en natuurlijke eigenschappen.":
      "For companies and teams that want to work together better through more insight into each other's strengths, communication and natural traits.",
    "Niet zeker welk pakket":"Not sure which package","bij jou past":"suits you",
    "Twijfel je tussen een rapport, een sessie of het volledige traject? Stel je vraag, we denken graag met je mee voordat je kiest.":
      "Torn between a report, a session or the full journey? Ask your question, we're happy to think along before you choose.",
    "Bekijk de veelgestelde vragen":"View the FAQs",

    // ---- Product (package) pages: breadcrumb + features + birth form + buy ----
    "Persoonlijke Analyse":"Personal Analysis",
    "Verdiepende Analyse + Live Sessie":"In-depth Analysis + Live Session",
    "Analyse + Persoonlijk Traject":"Analysis + Personal Journey",
    "Tier 01 · Persoonlijke Analyse":"Tier 01 · Personal Analysis",
    "Ontdek wat jouw geboortemoment zegt over wie je bent en hoe je werkt.":
      "Discover what your moment of birth says about who you are and how you work.",
    "Ontdek wat jouw geboortemoment vertelt over wie je bent en hoe jij door het leven beweegt.":
      "Discover what your moment of birth tells you about who you are and how you move through life.",
    "Aan de hand van jouw geboortegegevens ontvang je een uitgebreid PDF-rapport vol inzichten in jouw natuurlijke patronen, talenten en levensrichting. Praktisch, helder en zonder zweverige taal.":
      "Using your birth details you receive an extensive PDF report full of insights into your natural patterns, talents and life direction. Practical, clear and without vague language.",
    "Een krachtig vertrekpunt voor iedereen die zichzelf beter wil begrijpen en bewuster keuzes wil maken.":
      "A powerful starting point for anyone who wants to understand themselves better and make more conscious choices.",
    "Wat je krijgt":"What you get",
    "Persoonlijk PDF-rapport":"Personal PDF report",
    "Een uitgebreid, helder geschreven rapport op basis van jouw unieke geboortegegevens, direct na aanvraag in jouw inbox.":
      "An extensive, clearly written report based on your unique birth details, in your inbox right after ordering.",
    "Tier 01 · PDF-rapport":"Tier 01 · PDF report",
    "Geboorteprofiel":"Birth Profile",
    "Persoonlijke Analyse · Rapport":"Personal Analysis · Report",
    "Kernenergie":"Core energy","Werkstijl":"Work style","Levensrichting":"Life direction",

    // birth-data form (package pages)
    "Jouw geboortegegevens":"Your birth details",
    "De basis van je analyse, deze gaan automatisch mee naar het afrekenen. De geboortetijd bepaalt de exacte planeetstanden op jouw moment, daarom zijn alle velden verplicht.":
      "The basis of your analysis, these are carried automatically through to checkout. The time of birth determines the exact planetary positions at your moment, which is why all fields are required.",
    "Geboortedatum":"Date of birth","Geboortetijd":"Time of birth","Geboorteplaats":"Place of birth",
    "In winkelwagen":"Add to cart","Naar winkelwagen":"Go to cart","Toegevoegd ✓":"Added ✓",
    "Veilig betalen":"Secure payment","Direct geleverd":"Delivered instantly","Binnen 24 uur":"Within 24 hours",
    "Sessie in overleg":"Session by arrangement","Plan flexibel in":"Schedule flexibly",
    "Sessies in overleg":"Sessions by arrangement","Begeleiding tussendoor":"Guidance in between",
    "Vrijblijvend gesprek":"No-obligation call","Reactie binnen 48 uur":"Response within 48 hours","Op locatie of online":"On location or online",

    // ---- Cart ----
    "Winkelwagen":"Cart","Jouw winkelwagen":"Your cart",
    "Controleer je bestelling voordat je afrekent.":"Review your order before you check out.",
    "Pakket":"Package","Aantal":"Quantity","Prijs":"Price",
    "Overzicht":"Summary","Subtotaal":"Subtotal","Btw (21%, incl.)":"VAT (21%, incl.)","Korting":"Discount",
    "Kortingscode":"Discount code","Toepassen":"Apply","Toegepast":"Applied","Ongeldig":"Invalid",
    "Totaal":"Total","Afrekenen":"Checkout","Verder winkelen":"Continue shopping",
    "Veilige, versleutelde betaling":"Secure, encrypted payment",
    "Rapport binnen 24 tot 48 uur":"Report within 24 to 48 hours",
    "Je winkelwagen is leeg":"Your cart is empty",
    "Ontdek welk geboorteprofiel bij jou past en voeg het toe aan je winkelwagen.":
      "Find out which birth profile suits you and add it to your cart.",
    "Bekijk de pakketten":"View the packages",
    "Geboortegegevens ontbreken":"Birth details missing","vul ze in":"fill them in",
    "Persoonlijk PDF-rapport op basis van je geboortegegevens.":"Personal PDF report based on your birth details.",
    "PDF-rapport, 1 uur live sessie, actieplan & samenvatting.":"PDF report, 1-hour live session, action plan & summary.",
    "Rapport, 4 live sessies, plan van aanpak & begeleiding.":"Report, 4 live sessions, action plan & guidance.",

    // ---- Checkout ----
    "Betaling":"Payment","Gegevens":"Details","Afronden":"Complete",
    "Nog één stap, vul je gegevens in en kies je betaalmethode.":
      "One more step, enter your details and choose your payment method.",
    "Contactgegevens":"Contact details",
    "Geboortegegevens":"Birth details",
    "Hierheen sturen we je rapport en bevestiging.":"This is where we'll send your report and confirmation.",
    "Voornaam":"First name","Achternaam":"Last name","E-mailadres":"Email address","Telefoon (optioneel)":"Phone (optional)",
    "De basis van je analyse. Hoe nauwkeuriger, hoe persoonlijker je rapport. De geboortetijd bepaalt de exacte stand van de planeten op jouw moment, daarom zijn alle velden verplicht.":
      "The basis of your analysis. The more accurate, the more personal your report. The time of birth determines the exact position of the planets at your moment, which is why all fields are required.",
    "Betaalmethode":"Payment method",
    "Je wordt na bevestiging veilig doorgestuurd naar de betaalomgeving.":
      "After confirmation you'll be securely redirected to the payment environment.",
    "Creditcard":"Credit card",
    "← Terug naar de pakketten":"← Back to the packages",
    "Jouw bestelling":"Your order",
    "Betalen":"Pay","Veilig verbinden…":"Connecting securely…",
    "Versleutelde, beveiligde betaling":"Encrypted, secured payment",
    "Rapport binnen 24 tot 48 uur per e-mail":"Report within 24 to 48 hours by email",
    "Je gegevens worden niet gedeeld":"Your details are never shared",
    "Bedankt voor je bestelling":"Thank you for your order",
    "Terug naar home":"Back to home",
    "Jouw vragen":"Your questions",
    "Heb je specifieke vragen of thema's? Stel maximaal 3 vragen, ik neem ze persoonlijk mee in je analyse en werk ze uit in je rapport. (Optioneel)":"Do you have specific questions or themes? Ask up to 3 questions, I'll personally include them in your analysis and work them out in your report. (Optional)",
    "Hoe concreter je vraag, hoe gerichter het antwoord in je rapport.":"The more specific your question, the more focused the answer in your report.",

    // ---- FAQ (hero + structure) ----
    "Veelgestelde vragen":"Frequently asked questions",
    "Alles wat je wilt weten over geboorteprofielen, bestellen, betalen en privacy, helder op een rij.":
      "Everything you want to know about birth profiles, ordering, payment and privacy, clearly laid out.",
    "Categorieën":"Categories","Algemeen":"General","Bestelling":"Order","Privacy":"Privacy",

    // ---- About (hero + section headings) ----
    "Over Birth Profile Analyst":"About Birth Profile Analyst",
    "Inzicht begint waar aannames eindigen.":"Insight begins where assumptions end.",
    "De oprichter":"The founder",
    "Ontstaan vanuit observatie":"Born from observation",
    "De fundering":"The foundation",
    "Een bewust andere aanpak":"A deliberately different approach",
    "Wat een profiel onthult":"What a profile reveals",
    "Niet dit":"Not this","Maar dit":"But this",
    "Zweverige taal":"Vague, woolly language",
    "Analytische, persoonlijke benadering":"Analytical, personal approach",
    "Structuur, inzicht en zelfbewustzijn":"Structure, insight and self-awareness",
    "Bewustere besluitvorming":"More conscious decision-making",
    "Ontdek jouw":"Discover your","blauwdruk":"blueprint"
  };

  /* attribute (placeholder) translations */
  var ATTR = {
    "Begin te typen…":"Start typing…",
    "Stad, land":"City, country",
    "Kortingscode":"Discount code",
    "Voornaam":"First name",
    "Achternaam":"Last name",
    "jij@email.nl":"you@email.com",
    "Bijv. Waarom voel ik me vaak rusteloos in relaties?":"e.g. Why do I often feel restless in relationships?",
    "Bijv. Welk werk past het beste bij mijn aard?":"e.g. Which work best suits my nature?",
    "Bijv. Hoe ga ik beter om met stress en spanning?":"e.g. How can I better deal with stress and tension?",
    "Sleep hier een portret van Vicky":"Drag a portrait of Vicky here",
    "Jouw naam":"Your name",
    "Bedrijf / team":"Company / team",
    "jij@bedrijf.nl":"you@company.com",
    "bv. 8 personen":"e.g. 8 people",
    "Bijv. Tier 02":"e.g. Tier 02",
    "Deel hier je ervaring…":"Share your experience here…",
    "Waar gaat je vraag over?":"What is your question about?",
    "Schrijf hier je vraag of bericht…":"Write your question or message here…",
    "Waar willen jullie als team in groeien?":"Where do you want to grow as a team?"
  };

  /* page <title> translations */
  var TITLES = {
    "Geboorteprofiel · Persoonlijk inzicht uit jouw geboortedatum":"Birth Profile · Personal insight from your date of birth",
    "Diensten · Birth Profile Analyst":"Services · Birth Profile Analyst",
    "Winkelwagen · Birth Profile Analyst":"Cart · Birth Profile Analyst"
  };

  function getLang(){ return localStorage.getItem(LANG_KEY) || "nl"; }
  function setLang(l){ localStorage.setItem(LANG_KEY, l); }

  function norm(s){ return s.replace(/\s+/g, " ").trim(); }

  function translateTextNode(node){
    var raw = node.nodeValue;
    if(!raw || !raw.trim()) return;
    var key = norm(raw);
    var en = MAP[key];
    if(en && en !== key){
      var lead = (raw.match(/^\s*/) || [""])[0];
      var trail = (raw.match(/\s*$/) || [""])[0];
      node.nodeValue = lead + en + trail;
    }
  }

  var SKIP = { SCRIPT:1, STYLE:1, NOSCRIPT:1 };
  function walk(root){
    if(!root) return;
    if(root.nodeType === 3){ translateTextNode(root); return; }
    if(root.nodeType !== 1) return;
    if(SKIP[root.tagName]) return;
    // rich-content elements carry their full English (incl. markup) in data-en
    if(root.nodeType === 1 && root.hasAttribute && root.hasAttribute("data-en")){
      root.innerHTML = root.getAttribute("data-en");
      return; // don't recurse, English already complete
    }
    // attributes
    if(root.hasAttribute && root.hasAttribute("placeholder")){
      var ph = root.getAttribute("placeholder");
      if(ATTR[ph]) root.setAttribute("placeholder", ATTR[ph]);
    }
    var kids = root.childNodes, i;
    for(i=0;i<kids.length;i++) walk(kids[i]);
  }

  function applyEN(){
    document.documentElement.lang = "en";
    if(TITLES[document.title]) document.title = TITLES[document.title];
    walk(document.body);
  }

  /* ---- Language toggle button ---- */
  function buildToggle(){
    var nav = document.querySelector(".nav-inner");
    if(!nav || nav.querySelector(".lang-toggle")) return;
    var lang = getLang();
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lang-toggle";
    btn.setAttribute("aria-label", lang === "en" ? "Schakel naar Nederlands" : "Switch to English");
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/>' +
      '<path d="M12 3c2.6 2.5 4 5.7 4 9s-1.4 6.5-4 9c-2.6-2.5-4-5.7-4-9s1.4-6.5 4-9z"/></svg>' +
      '<span>' + (lang === "en" ? "NL" : "EN") + '</span>';
    btn.addEventListener("click", function(){
      setLang(getLang() === "en" ? "nl" : "en");
      location.reload();
    });
    nav.appendChild(btn);
  }

  function injectStyle(){
    var css =
      ".lang-toggle{display:inline-flex;align-items:center;gap:7px;border:1px solid rgba(201,169,106,0.55);" +
      "color:#f3ead6;background:transparent;font-family:'JetBrains Mono',ui-monospace,monospace;font-size:10px;" +
      "letter-spacing:.18em;text-transform:uppercase;padding:8px 12px;cursor:pointer;line-height:1;" +
      "transition:background .25s,color .25s,border-color .25s;margin-left:8px}" +
      ".lang-toggle:hover{background:#c9a96a;color:#0a1733;border-color:#c9a96a}" +
      ".lang-toggle svg{width:13px;height:13px;flex:0 0 auto}" +
      "@media (max-width:860px){.lang-toggle{margin-left:auto}}" +
      ".flinks{display:flex;justify-content:center;gap:22px;margin:0 0 20px;flex-wrap:wrap}" +
      ".flinks a{font-family:'JetBrains Mono',ui-monospace,monospace;font-size:10px;letter-spacing:.28em;" +
      "text-transform:uppercase;color:#8b94ad;text-decoration:none;transition:color .25s;padding-bottom:3px;" +
      "border-bottom:1px solid transparent}" +
      ".flinks a:hover{color:#c9a96a;border-bottom-color:rgba(201,169,106,0.5)}" +
      ".flinks a.active{color:#c9a96a}";
    var s = document.createElement("style");
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init(){
    injectStyle();
    buildToggle();
    if(getLang() === "en"){
      applyEN();
      // catch dynamically added nodes (cart rows, autocomplete, chart labels)
      var mo = new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var added = muts[i].addedNodes;
          for(var j=0;j<added.length;j++) walk(added[j]);
        }
      });
      mo.observe(document.body, { childList:true, subtree:true });
    }
  }

  if(document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
